export enum UserSettingsPages {
    GENERAL = "general",
    RECEIPTS = "receipts",
    SECURITY = "security",
    NOTIFICATIONS = "notifications",
}

export enum WorkspaceSettingsPages {
    INTEGRATIONS = "integrations",
    DIRECTORY = "directory",
    MEMBERS = "members",
    LOCKS = "locks",
    BILLING = "billing",
    PLANS = "plans",
}

export enum EntitySettingsPages {
    ACCOUNTS = "accounts",
    ALLOCATION = "allocation",
    SETTINGS = "settings",
    PAYROLL = "payroll",
    CATEGORIES = "categories",
}
